import { Component, OnInit, Inject } from '@angular/core';
import { DialogService } from '../../../shared/services/dialog.service';
import { MdInputModule, MdCheckboxModule, MdDialog, MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { BaseService } from '../../../shared/services/base.service';
import { DialogComponent } from '../../../components/dialog/dialog.component';
import { FormGroup, FormBuilder, Validators, AbstractControl, FormControl } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { FormMessageComponent } from '../../../components/form/message/message.component';
import { AppConstants } from '../../../shared/constants/constants';
import { AppMessages } from '../../../shared/constants/messages';
import { AddTMBStaffModel } from '../../../models/booking/booking-details.model';

@Component({
    selector: 'add-tmb-staff',
    templateUrl: 'add-tmb-staff-popup.component.html',
})

export class AddTMBStaffPopupComponent implements OnInit {
    public addTMBStaffModel = new AddTMBStaffModel();
    public addTMBStaffForm: FormGroup;
    public dataStaff = [];
    constructor(
        public formBuilder: FormBuilder,
        public utility: Utility,
        public dialogRef: MdDialogRef<AddTMBStaffPopupComponent>,
        public dialogService: DialogService,
        @Inject(MD_DIALOG_DATA) public data: any
    ) {
        this.dataStaff = this.data ? this.data.dataStaff : new Array<AddTMBStaffModel>();
        this.createForm();
    }

    ngOnInit() {
    }

    createForm() {
        this.addTMBStaffForm = this.formBuilder.group({
            staffName: ['', [Validators.required, this.nameValidator(this.dataStaff)]],
            role: ['', [Validators.required]]
        });
    }

    nameValidator(arr: Array<AddTMBStaffModel>) {
        return (input: FormControl) => {
            if (input.value) {
                const index = arr.findIndex(v => v.staffName.toLowerCase() === input.value.toLowerCase());
                return index < 0 ? null : { 'sameNames': true };
            }
            return null;
        };
    }

    onCloseDialog() {
        this.dialogRef.close();
    }

    onSave() {
        if (this.addTMBStaffForm.dirty && this.addTMBStaffForm.valid) {
            this.dataStaff.push(this.addTMBStaffForm.value);
            this.dialogRef.close(this.dataStaff);
        }
    }

    onSaveAnother() {
        if (this.addTMBStaffForm.dirty && this.addTMBStaffForm.valid) {
            this.dataStaff.push(this.addTMBStaffForm.value);
            this.addTMBStaffForm.reset();
        }

    }

}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/booking/list-member/add-tmb-staff-popup.component.ts